import type { Coordinates, DrawingStore } from "./DrawingProvider.types";

export const initialState: DrawingStore = {
  coordinates: [],
};

export const drawingReducerActions = {
  SET_COORDINATES: "SET_COORDINATES",
  CLEAR_COORDINATES: "CLEAR_COORDINATES",
} as const;

interface SetCoordinatesAction {
  type: typeof drawingReducerActions.SET_COORDINATES;
  payload: Coordinates[];
}

interface ClearCoordinatesAction {
  type: typeof drawingReducerActions.CLEAR_COORDINATES;
}

type Action = SetCoordinatesAction | ClearCoordinatesAction;

function drawingReducer(state: typeof initialState, action: Action) {
  switch (action.type) {
    case drawingReducerActions.SET_COORDINATES: {
      return { ...state, coordinates: action.payload };
    }
    case drawingReducerActions.CLEAR_COORDINATES: {
      return { ...state, coordinates: [] };
    }
    default:
      return state;
  }
}

export default drawingReducer;
